import { TevvEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const uploadTevvDocument = async (
  templateId: string,
  data: any
): Promise<any> =>
  APIManager.sendPost(
    TevvEnds.UPLOAD_FILE(templateId),
    data,
    true,
    {},
    {},
    axios
  );

const getFileDetail = async (templateId: string): Promise<any> =>
  APIManager.sendGet(
    TevvEnds.GET_FILE_DETAILS(templateId),
    true,
    {},
    {},
    axios
  );

const getFiles = async (fileId: string): Promise<any> =>
  APIManager.sendGet(TevvEnds.GET_FILE(fileId), true, {}, {}, axios);

const deleteFiles = async (templateId: string, fieldId: string): Promise<any> =>
  APIManager.sendDelete(
    TevvEnds.DELETE_FILE(templateId, fieldId),
    true,
    {},
    {},
    axios
  );

const downLoadFile = async (templateId: string, fileId: string): Promise<any> =>
  APIManager.sendPut(
    TevvEnds.DOWNLOAD_FILE(templateId, fileId),
    {},
    true,
    {},
    {},
    axios
  );

export const TEVVService = {
  uploadTevvDocument,
  getFileDetail,
  deleteFiles,
  getFiles,
  downLoadFile,
};
